import { BotDetails } from 'enablex/sdk'
import { Button, Intent } from '@blueprintjs/core'
import { lang, toast } from 'enablex/shared'
import React, { FC, useEffect, useState } from 'react'
import api from '~/app/api'
import CodeSnippetIcon from '~/icons/CodeSnippetIcon'
import style from './style.scss'
import CopyIcon from '~/icons/CopyIcon'
interface Props {
    botId: string | null
    name: string
    whiteListedDomains: string[]
    details: BotDetails
    isOpen: boolean
    toggle: () => void
}

interface ModalProps {
    modalProps: Props
}

const VoiceBotTab: FC<ModalProps> = props => {
    const axios = api.getSecured({ useV1: false })
    const { modalProps } = props
    const [QR, setQR] = useState('')
    const voiceBotURL = `tel:${modalProps?.details?.selectedProject?.voice_phone_number}`

    const copyURLToClipboard = async () => {
        const preElement = document.querySelector('pre#copy-voice-bot-url')
        const codeText = preElement?.textContent
        if(codeText) {
        navigator.clipboard.writeText(codeText)
        .then(() => {
            console.log('Text copied to clipboard')
            toast.info('Copied to clipboard')
        })
        .catch((error) => {
            console.error('Failed to copy text to clipboard:', error)
        })
        }
    }

    const fetchQR = async () => {
        const data = {
            url: voiceBotURL
        }
        try {
            const response = await axios.post(`admin/workspace/bots/${modalProps.botId}/get_QR`, data)
            // console.log('fetchQR: rsp', response)
            setQR(response.data.base64DataUrl)
        } catch (error) {
            console.log('fetchQR: rsp', error)
        }

    }

    useEffect(() => {
        if(!QR) {
            const res = fetchQR()
        }
    }, [])

    return (
        <>
            {
                !QR ?
                <span>Sorry! Cannot create QR code at this moment</span> :
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{fontFamily: 'Barlow SemiBold'}}>Share phone number</span>
                    <div className={style.urlContainer}>
                        <pre id="copy-voice-bot-url">{modalProps?.details?.selectedProject?.voice_phone_number}</pre>
                        <Button
                            className={style.copyBtn}
                            icon={<CopyIcon />}
                            tabIndex={3}
                            onClick={copyURLToClipboard}
                            intent={Intent.PRIMARY}
                        />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div id={'download-voiceBot-QR'} className={style.cardContainer}>
                            <p style={{fontFamily: 'Barlow SemiBold', fontSize: 'large', color: '#8BC34A'}}>{modalProps.name}</p>
                            <img src={QR} />
                            <p style={{fontFamily: 'Barlow SemiBold', fontSize: 'large'}}>Scan QR code to call</p>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default VoiceBotTab
